import React from 'react';

const CompanyTeamContext = React.createContext({})

export default CompanyTeamContext;